import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import BaseMesh from './base-mesh';
class Person2d extends BaseMesh {
    tween;
    disposeStatus = false;
    constructor(data) {
        super(data);
        const { position } = data;
        this.tween = new TWEEN.Tween({
            x1: position.x,
            y1: position.y,
            z1: position.z,
        });
        this.update(data, true);
    }
    update(data, isInit = false) {
        const { visible = true, opacity = 1, position, onUpdate } = data;
        const { url: newUrl, width: newWdith, height: newHeight } = data.renderProps;
        const { url } = this.props.renderProps;
        if (newUrl !== url || isInit) {
            this._createTexture(newUrl).then(({ texture, ratio, width: realWidth, height: realHeight }) => {
                this.material = new THREE.MeshBasicMaterial({
                    map: texture,
                    side: THREE.FrontSide,
                    transparent: true,
                    depthTest: false,
                    opacity,
                });
                if (!newWdith && !newHeight) {
                    this.geometry = new THREE.PlaneGeometry(realWidth, realHeight); // 二维矩形平面
                }
                else if (!newWdith) {
                    this.geometry = new THREE.PlaneGeometry(newHeight * ratio, newHeight); // 二维矩形平面
                }
                else if (!newHeight) {
                    this.geometry = new THREE.PlaneGeometry(newWdith, newWdith / ratio); // 二维矩形平面
                }
                else {
                    this.geometry = new THREE.PlaneGeometry(newWdith, newHeight); // 二维矩形平面
                }
                this.material.opacity = opacity;
                super.update(data);
            }, () => {
                this.dispose();
            });
        }
        else {
            // 位置更新
            this.tween
                .stop()
                .to({
                x1: position.x,
                y1: position.y,
                z1: position.z,
            }, 10000)
                .onUpdate((obj) => {
                if (this.disposeStatus) {
                    this.tween.stop();
                    return;
                }
                this.position.set(obj.x1, obj.y1, obj.z1);
            })
                .onComplete(() => {
                if (this.disposeStatus)
                    return;
                this.props = data;
            })
                .start();
        }
        this.visible = visible;
        // 处理完更新操作后替换props
        if (onUpdate && typeof onUpdate === 'function') {
            onUpdate(this);
        }
    }
    _createTexture(url) {
        return new Promise((resolve, reject) => {
            const loader = new THREE.TextureLoader();
            loader.crossOrigin = 'Anonymous';
            loader.load(url, (texture) => {
                const width = texture.image.width;
                const height = texture.image.height;
                const ratio = width / height;
                // 去除黑边
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.needsUpdate = true;
                resolve({ texture, ratio, width, height });
            }, undefined, (err) => {
                reject(err);
            });
        });
    }
    dispose() {
        // TODO:纹理清除是否可以
        this.disposeStatus = true;
        super.dispose();
    }
    onClick() {
        super.onClick();
    }
    onMouseEnter() {
        super.onMouseEnter();
    }
    onMouseLeave() {
        super.onMouseLeave();
    }
}
export default Person2d;
